const ClubLocatorSettings = {
    API_URL: 'https://test-club-locator-api.kiwanis.org/',
};

export default ClubLocatorSettings;
